/* eslint-disable consistent-return */
import apolloClient from '../../../core/backendClient/apolloClient';
import Schemas from './graphql';

/**
 * @param {String} storeId
 * @param {String} orderId
 * @param {String} zipCode
 * @returns {Promise<{devolutionPageConfigs: object,
 *                    storeConfigs: object,
 *                    order: object,
 *                    lockersInfo: object[],
 *                    integrationStatus: object} | null>}
 */
async function getReturnMethodPageData(storeId, orderId, zipCode = null) {
  const res = await apolloClient.query({
    query: Schemas.GET_SELECT_RETURN_LOCATION_PAGE_DATA,
    variables: { storeId, orderId, zipCode, buildTemplatedEmailHtml: true },
  });
  if (
    res.data.devolutionPageConfigs &&
    res.data.devolutionPageConfigs.code === 200 &&
    res.data.storeConfigs &&
    res.data.storeConfigs.code === 200 &&
    res.data.order &&
    res.data.order.code === 200 &&
    res.data.lockersInfo &&
    res.data.lockersInfo.code === 200 &&
    res.data.integrationStatus &&
    res.data.integrationStatus.code === 200
  ) {
    return {
      devolutionPageConfigs: res.data.devolutionPageConfigs.configs,
      storeConfigs: res.data.storeConfigs.storeConfigs,
      order: res.data.order.order,
      lockersInfo: res.data.lockersInfo.lockersInfo,
      integrationStatus: res.data.integrationStatus.status,
    };
  }
  return null;
}

/**
 * @param {String} storeId
 * @param {Number} returnMethodIndex
 * @param {String} boxCode
 * @returns {Promise<{success: true} | {success: false, message: String}>}
 */
async function setOrderReturnMethod({ orderId, returnMethodIndex, boxCode }) {
  // CliqueRetire
  if (returnMethodIndex === 1) {
    if (!boxCode) {
      return {
        success: false,
        message: 'Para prosseguir, selecione uma locker!',
      };
    }
    const res = await apolloClient.mutate({
      mutation: Schemas.SET_CR_RETURN_METHOD,
      variables: { encOrderId: orderId, boxCode },
    });
    if (
      res.data.setCliqueRetireReturnMethod &&
      res.data.setCliqueRetireReturnMethod.code === 200
    ) {
      return { success: true };
    }
    return {
      success: false,
      message: res.data.setCliqueRetireReturnMethod.message,
    };
  }
  if (returnMethodIndex === 2) {
    // Correios
    const res = await apolloClient.mutate({
      mutation: Schemas.SET_CORREIOS_RETURN_METHOD,
      variables: { encOrderId: orderId },
    });
    if (
      res.data.setCorreiosReturnMethod &&
      res.data.setCorreiosReturnMethod.code === 200
    ) {
      return { success: true };
    }
    return {
      success: false,
      message: res.data.setCorreiosReturnMethod.message,
    };
  }
}

/**
 * @param {String} storeId
 * @param {Boolean} choice
 * @returns {Promise<object>}
 */
async function approveOrRejectOrder({ orderId, choice }) {
  const res = await apolloClient.mutate({
    mutation: Schemas.APPROVE_OR_REJECT_ORDER,
    variables: { orderId, choice },
  });
  if (
    res.data.approveOrRejectOrder &&
    res.data.approveOrRejectOrder.code === 200
  ) {
    return res.data.approveOrRejectOrder.data;
  }
  return null;
}

async function getStoreIdByNameId(storeNameId) {
  const res = await apolloClient.query({
    query: Schemas.GET_STORE_ID_BY_STORE_NAME_ID,
    variables: { storeNameId },
  });
  if (res.data.getStoreByStoreNameId.code === 200) {
    return res.data.getStoreByStoreNameId.store.id;
  }
  return null;
}

async function getLockersByZipCode(storeId = '', zipCode = null) {
  const res = await apolloClient.query({
    query: Schemas.GET_LOCKERS_INFO,
    variables: { zipCode: zipCode === '' ? null : zipCode, storeId },
    fetchPolicy: 'no-cache',
  });
  if (
    res.data.getCliqueRetireLockersInfo &&
    res.data.getCliqueRetireLockersInfo.code === 200
  ) {
    return res.data.getCliqueRetireLockersInfo.lockersInfo;
  }
  return null;
}

export default {
  getReturnMethodPageData,
  setOrderReturnMethod,
  approveOrRejectOrder,
  getStoreIdByNameId,
  getLockersByZipCode,
};
